import { Modal } from './index';
import PropertyGalleryStage from './PropertyGalleryStage';
import './ReviewPhotoLightbox.css';

/**
 * Fullscreen, swipeable viewer for review photos - reuses
 * PropertyGalleryStage (the same swipe/arrow-key/thumbnail-strip stage the
 * property's own gallery already uses at size="fullscreen") instead of
 * building a second carousel. `images` is the flattened set of every photo
 * across every review on the page, not just the one that was clicked, so
 * swiping moves through all of them, not just the photos from a single
 * review.
 */
function ReviewPhotoLightbox({ isOpen, images, activeIndex, onActiveIndexChange, onClose }) {
  if (!isOpen || !images.length) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      className="review-photo-lightbox"
      title="Review photos"
    >
      <PropertyGalleryStage
        images={images}
        activeIndex={activeIndex}
        onActiveIndexChange={onActiveIndexChange}
        altText="Review photo"
        size="fullscreen"
      />
    </Modal>
  );
}

export default ReviewPhotoLightbox;
